import { createFileRoute } from "@tanstack/react-router";
import { ARCHIVE_BUCKET, ARCHIVE_PATH } from "@/lib/archive-constants";

/**
 * Public, read-only: the gzipped public archive (only visible videos/channels,
 * no private fields). The browser decompresses it itself.
 */
export const Route = createFileRoute("/api/public/archive")({
  staticData: { sitemap: false },
  server: {
    handlers: {
      GET: async () => {
        const { supabaseAdmin } = await import("@/integrations/supabase/client.server");
        const { data, error } = await supabaseAdmin.storage.from(ARCHIVE_BUCKET).download(ARCHIVE_PATH);
        if (error || !data) return new Response("Not found", { status: 404 });
        return new Response(await data.arrayBuffer(), {
          headers: {
            "content-type": "application/octet-stream",
            "cache-control": "public, max-age=60, stale-while-revalidate=600",
          },
        });
      },
    },
  },
});
